import type { SVGProps } from "react";
export interface Loading02IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Loading02Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Loading02IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M10.876 22v-1.5a1.125 1.125 0 0 1 2.25 0V22a1.125 1.125 0 0 1-2.25 0m-4.1-3.201a1.125 1.125 0 0 1 1.948 1.125l-.75 1.3a1.125 1.125 0 0 1-1.949-1.126l.75-1.3Zm8.912-.412a1.125 1.125 0 0 1 1.473.315l.063.097.75 1.3.053.102a1.126 1.126 0 0 1-1.938 1.119l-.063-.097-.75-1.3-.053-.102a1.125 1.125 0 0 1 .464-1.434ZM4.075 15.276A1.126 1.126 0 1 1 5.2 17.224l-1.298.75a1.126 1.126 0 1 1-1.125-1.948zm14.311.412a1.125 1.125 0 0 1 1.434-.465l.103.053 1.3.75.096.063a1.125 1.125 0 0 1-1.12 1.938l-.102-.053-1.3-.75-.096-.063a1.125 1.125 0 0 1-.315-1.474ZM3.5 10.875l.116.006a1.125 1.125 0 0 1 0 2.239l-.116.006H2a1.125 1.125 0 0 1 0-2.25h1.5Zm18.5 0 .115.006a1.125 1.125 0 0 1 0 2.239l-.115.006h-1.5a1.126 1.126 0 0 1 0-2.25H22ZM2.364 6.438A1.127 1.127 0 0 1 3.8 5.973l.103.052 1.298.75.096.063a1.125 1.125 0 0 1-1.119 1.938l-.102-.052-1.298-.75-.097-.062a1.126 1.126 0 0 1-.316-1.475Zm17.733-.412a1.126 1.126 0 0 1 1.125 1.949l-1.3.75a1.125 1.125 0 1 1-1.122-1.95l1.3-.75Zm-4.072-3.247a1.126 1.126 0 1 1 1.948 1.125l-.75 1.298a1.126 1.126 0 1 1-1.948-1.125zm-5.15.722V2a1.125 1.125 0 0 1 2.25 0v1.5a1.125 1.125 0 0 1-2.25 0Z"
      />
    </svg>
  );
}
